import {
  Box,
  Button,
  Stack,
  Typography,
  CircularProgress,
} from "@mui/material";
import MaterialModal from "../../../../app/material-modal";

const PendingUserActionModal = ({
  open,
  title,
  singleInviteUserData,
  handleClose,
}) => {
  return (
    <MaterialModal
      title={title}
      open={open}
      onClose={handleClose}
      handleDialogClose={handleClose}
      styleOverrides={{
        container: {
          "& .MuiDialog-paper": {
            minWidth: "200px",
            minHeight: "200px",
          },
        },
      }}
    >
      <Box>
        <Typography variant="subtitle1">
          Are you sure you want to {title} for user {singleInviteUserData.name}
        </Typography>

        <Stack direction="row" justifyContent="flex-end" gap={1} mt={2}>
          <Button variant="outlined" onClick={handleClose}>
            No
          </Button>
          <Button
            //   disabled={isPending}
            variant="contained"
            onClick={() => {}}
            //   endIcon={ isPending ? ( <CircularProgress size={15} color="primary" /> ) : null }
          >
            Yes
          </Button>
        </Stack>
      </Box>
    </MaterialModal>
  );
};

export default PendingUserActionModal;
